import axios from "axios";
import { BASE_URL } from "../util/constant";

export const apiClient = axios.create({ baseURL: BASE_URL });

let _token = "";

/** Called by the auth context whenever the access token changes. */
export function setApiToken(token: string): void {
  _token = token;
}

apiClient.interceptors.request.use((config) => {
  if (_token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${_token}`;
  }
  return config;
});
